import React from "react";
import { LogoImage, PlatformName, HeaderDiv } from "./Header.styles";
import logo from "../../../assets/tinsa_logo.png";

function Header() {
  return (
    <HeaderDiv>
      <PlatformName>TinsaCore</PlatformName>
      <LogoImage src={logo} />
    </HeaderDiv>
  );
}
export default Header;
